import { CorrespondenceViewTaskFilter } from "acquaint-api/constants/CorrespondenceViewTaskFilter";
export class TaskListFilters {
  types: number[] = [];
  status: number = CorrespondenceViewTaskFilter.AllTasks;
  assignedTo: number[] = [];
}
